'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import ContextComponent from './ContextComponent';

import style from './ConfirmationModal-style.scss';

import SanitizeHtml from './SanitizeHtml';

import PrimaryButton from 'dibs-elements/dist/Button/Primary';
import BarHeader from 'dibs-elements/dist/BarHeader';
import ModalBody from 'dibs-elements/dist/ModalBody';
import ModalCloseButton from 'dibs-elements/dist/ModalCloseButton';
import ModalContainer from 'dibs-elements/dist/ModalContainer';

class ConfirmationModal extends ContextComponent {
    constructor(props) {
        super(props);

        this._close = this._close.bind(this);
        this._cancel = this._cancel.bind(this);
        this._confirm = this._confirm.bind(this);
    }

    _cancel(event) {
        event.preventDefault();
        const { onCancel } = this.props;
        onCancel();
    }

    _confirm(event) {
        event.preventDefault();
        const { onConfirm } = this.props;
        onConfirm();
    }

    _close(event) {
        event.preventDefault();
        const { onClose } = this.props;
        onClose();
    }

    render() {
        const { isOpen, header, message, confirmCta, cancelCta } = this.props;

        return (
            <ModalContainer isOpen={isOpen} onClose={this._close} closeOnEsc modalPosition="center">
                <BarHeader title={header} />
                <ModalCloseButton onClick={this._close} />
                <ModalBody>
                    <div className="modal-simple-message">
                        <SanitizeHtml content={message} />
                    </div>

                    <div className={style.ctaWrapper}>
                        <PrimaryButton
                            size="medium"
                            onClick={this._confirm}
                            className={style.button}
                        >
                            {confirmCta}
                        </PrimaryButton>
                        <div>
                            <a onClick={this._cancel} className={style.cancel} href="#">
                                {cancelCta}
                            </a>
                        </div>
                    </div>
                </ModalBody>
            </ModalContainer>
        );
    }
}

ConfirmationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    header: PropTypes.node.isRequired,
    message: PropTypes.node.isRequired,
    confirmCta: PropTypes.node.isRequired,
    cancelCta: PropTypes.node.isRequired,
};

module.exports = ConfirmationModal;



// WEBPACK FOOTER //
// ./assets/js/global/components/ConfirmationModal.jsx